export default __webpack_public_path__ + "static/treinamento01-d56663e558c2377c6390e47b43e87182.jpeg";